import * as actionTypes from "./affiliateActionType";
import axios from 'axios';
import { checkError, apiTimeout } from './../error';
import { toast } from 'react-toastify';
const { REACT_APP_API_URL } = process.env;

export const affiliateCreate = (data) => {
    return (dispatch) => {
        dispatch(affiliateCreateInit());
        apiTimeout(axios.post(`${REACT_APP_API_URL}/affiliate/register`, data))
        .then((response) => {
            toast.success("We received your request. We will contact you for more information.", {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored"
            });
            dispatch(affiliateCreateSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(affiliateCreateFailure());
            checkError(error);
        })
    };
};

export const affiliateCreateInit = () => ({
    type: actionTypes.AFFILIATE_CREATE
});

export const affiliateCreateFailure = () => ({
    type: actionTypes.AFFILIATE_CREATE_FAILURE
});

export const affiliateCreateSuccess = data => ({
    type: actionTypes.AFFILIATE_CREATE_SUCCESS,
    payload: { data }
});

export const affiliateLogin = (data) => {
    return (dispatch) => {
        dispatch(affiliateLoginInit());
        apiTimeout(axios.post(`${REACT_APP_API_URL}/affiliate/authenticate`, data))
        .then((response) => {
            setAffiliateSession(response.data.data);
            dispatch(affiliateLoginSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(affiliateLoginFailure());
            checkError(error);
        });
    };
};

export const affiliateLoginInit = () => ({
    type: actionTypes.AFFILIATE_LOGIN
});

export const affiliateLoginFailure = () => ({
    type: actionTypes.AFFILIATE_LOGIN_FAILURE
});

export const affiliateLoginSuccess = data => ({
    type: actionTypes.AFFILIATE_LOGIN_SUCCESS,
    payload: { data }
});

export const affiliateLogout = () => {
    return (dispatch) => {
        sessionStorage.removeItem("loggedAffiliate");
        sessionStorage.removeItem("affiliateToken");
        dispatch({ type: actionTypes.AFFILIATE_LOGOUT });
    };
};

function setAffiliateSession(data) {
    sessionStorage.setItem("loggedAffiliate", JSON.stringify(data));
    sessionStorage.setItem("affiliateToken", data.token);
}

export const getAffiliateProfile = () => {
    const config = { headers: { Authorization: `Bearer ${sessionStorage.getItem('affiliateToken')}` } };
    return (dispatch) => {
        dispatch({ type: actionTypes.GET_AFFILIATE_PROFILE });
        apiTimeout(axios.get(`${REACT_APP_API_URL}/affiliate/current`, config))
        .then((response) => {
            sessionStorage.setItem("loggedAffiliate", JSON.stringify(response.data.data));
            dispatch({ type: actionTypes.GET_AFFILIATE_PROFILE_SUCCESS, payload: { data: response.data.data } });
        })
        .catch(function (error) {
            dispatch({ type: actionTypes.GET_AFFILIATE_PROFILE_FAILURE });
            checkError(error);
        });
    };
};

export const getAffiliateOrders = (limit = 10, offset = 0, month = '') => {
    const config = { headers: { Authorization: `Bearer ${sessionStorage.getItem('affiliateToken')}` }, params: { limit, offset } };
    if (month) {
        config.params.month = month;
    }
    return (dispatch) => {
        dispatch({ type: actionTypes.GET_AFFILIATE_ORDERS });
        apiTimeout(axios.get(`${REACT_APP_API_URL}/order/affiliate`, config))
        .then((response) => {
            dispatch({ type: actionTypes.GET_AFFILIATE_ORDERS_SUCCESS, payload: { data: response.data.data } });
        })
        .catch(function (error) {
            dispatch({ type: actionTypes.GET_AFFILIATE_ORDERS_FAILURE });
            checkError(error);
        });
    };
};

export const getAffiliateOrdersCount = (month = '') => {
    const config = { headers: { Authorization: `Bearer ${sessionStorage.getItem('affiliateToken')}` }, params: {} };
    if (month) {
        config.params.month = month;
    }
    return (dispatch) => {
        dispatch({ type: actionTypes.GET_AFFILIATE_ORDERS_COUNT });
        apiTimeout(axios.get(`${REACT_APP_API_URL}/order/affiliate/count`, config))
        .then((response) => {
            dispatch({ type: actionTypes.GET_AFFILIATE_ORDERS_COUNT_SUCCESS, payload: { data: response.data.data } });
        })
        .catch(function (error) {
            dispatch({ type: actionTypes.GET_AFFILIATE_ORDERS_COUNT_FAILURE });
            checkError(error);
        });
    };
};

export const affiliateForgotPassword = (data) => {
    return (dispatch) => {
      dispatch(affiliateForgotPasswordInit());
      apiTimeout(axios.post(`${REACT_APP_API_URL}/affiliate/forget-password`, data))
      .then((response) => {
            toast.success("Email sent to registered email address. Follow to recover password.", {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored"
            });
          dispatch(affiliateForgotPasswordSuccess(response.data.data));
      })
      .catch(function (error) {
          dispatch(affiliateForgotPasswordFailure());
          checkError(error);
      })
  };
};

export const affiliateForgotPasswordInit = () => ({
  type: actionTypes.AFFILIATE_FORGOT_PASSWORD
});

export const affiliateForgotPasswordFailure = () => ({
  type: actionTypes.AFFILIATE_FORGOT_PASSWORD_FAILURE
});

export const affiliateForgotPasswordSuccess = data => ({
  type: actionTypes.AFFILIATE_FORGOT_PASSWORD_SUCCESS,
  payload: { data }
});

export const affiliateResetPassword = (token, data) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    return (dispatch) => {
      dispatch(affiliateResetPasswordInit());
      apiTimeout(axios.post(`${REACT_APP_API_URL}/affiliate/reset-password`, data, config))
      .then((response) => {
        toast.success("Your password has been reset. Please login again", {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored"
        });
          dispatch(affiliateResetPasswordSuccess(response.data.data));
      })
      .catch(function (error) {
          dispatch(affiliateResetPasswordFailure());
          checkError(error);
      })
  };
};

export const affiliateResetPasswordInit = () => ({
  type: actionTypes.AFFILIATE_RESET_PASSWORD
});

export const affiliateResetPasswordFailure = () => ({
  type: actionTypes.AFFILIATE_RESET_PASSWORD_FAILURE
});

export const affiliateResetPasswordSuccess = data => ({
  type: actionTypes.AFFILIATE_RESET_PASSWORD_SUCCESS,
  payload: { data }
});

